import React, { useEffect } from 'react'
// helpers
import requestSSOAuthToken from 'src/dataLayer/remoteData/babbelAPI/requestSSOAuthToken'
import { Layout, Spinner } from 'src/viewLayer/components/DesignSystem'
// hooks
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown'
import { postMessage } from 'src/viewLayer/helpers/safeNativeReporter'

export default function SuccessCallbackPage({ appType, path }) {
  useTrackPageShown({ appType, pageType: `b2b_sso_${path || 'success'}` })

  useEffect(() => {
    requestSSOAuthToken().then(({ authenticationToken }) => {
      if (authenticationToken) {
        postMessage(authenticationToken)
      }
    })
  }, [])

  return (
    <Layout align="center" padding={[150, 0]}>
      <Spinner data-testid="babbel-spinner" size={42} />
    </Layout>
  )
}
